module.exports = __webpack_public_path__ + "static/media/home-graphic-5.5b7f0696.png";